import { useDraggable } from '@dnd-kit/core';
import { contentIcons } from '../utils/iconMap';

const blockTypes = [
  { type: 'header', label: 'Header', icon: contentIcons.heading, defaultContent: 'Heading Text' },
  { type: 'text', label: 'Text', icon: contentIcons.text, defaultContent: 'Paragraph text...' },
  { type: 'button', label: 'Button', icon: contentIcons.link, defaultContent: 'Click Here' },
  { type: 'image', label: 'Image', icon: contentIcons.image, defaultContent: '' },
  { type: 'divider', label: 'Divider', icon: null, defaultContent: '' },
  { type: 'spacer', label: 'Spacer', icon: contentIcons.layout, defaultContent: '' },
];

function DraggableBlock({ blockType }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `palette-${blockType.type}`,
    data: {
      type: 'palette-item',
      blockType: blockType.type,
      defaultContent: blockType.defaultContent,
    },
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  const IconComponent = blockType.icon;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`
        flex items-center gap-2 p-3 mb-2 bg-white border border-gray-200 rounded-lg cursor-grab
        hover:bg-gray-50 hover:border-blue-300 transition-colors
        ${isDragging ? 'opacity-50' : ''}
      `}
    >
      {IconComponent && <IconComponent size={18} className="text-gray-500" />}
      <span className="text-sm font-medium text-gray-700">{blockType.label}</span>
    </div>
  );
}

export default function BlockPalette() {
  return (
    <div className="w-64 bg-gray-50 border-r border-gray-200 p-4 h-full overflow-y-auto">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Blocks</h3>
      <div className="space-y-2">
        {blockTypes.map((blockType) => (
          <DraggableBlock key={blockType.type} blockType={blockType} />
        ))}
      </div>
    </div>
  );
}

export { blockTypes };

